import { render } from "./back.vue?vue&type=template&id=105006cb&scoped=true&ts=true"
import script from "./back.vue?vue&type=script&lang=ts"
export * from "./back.vue?vue&type=script&lang=ts"

import "./back.vue?vue&type=style&index=0&id=105006cb&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105006cb"]])

export default __exports__